.input[type="number"]::-webkit-outer-spin-button,
.input[type="number"]::-webkit-inner-spin-button {
  @apply bg-no-repeat bg-center rounded-r-sm dark:invert;
  appearance: none;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAKUlEQVQYlWNgwAT/sYhhKPiPT+F/LJgEsHv37v+EMGkmkuImoh2NoQAANlcun/q4OoYAAAAASUVORK5CYII=");
  position: absolute;
  top: 0;
  right: 0.75rem;
  bottom: 0;
  width: 1em;
  opacity: 0.5;
}
.input[type="number"].sm,
.input[type="number"].xs {
  @apply relative pr-px;
}
.input[type="number"].sm::-webkit-outer-spin-button,
.input[type="number"].sm::-webkit-inner-spin-button,
.input[type="number"].xs::-webkit-outer-spin-button,
.input[type="number"].xs::-webkit-inner-spin-button {
  right: 0;
}
